"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var cell_model_1 = require("../../../model/layout/cell-model");
var interpreter_utils_1 = require("../../../interpreter-utils");
var control_model_reader_1 = require("./control-model-reader");
var layout_reader_1 = require("./layout-reader");
var __1 = require("../../..");
var CellModelReader = /** @class */ (function (_super) {
    __extends(CellModelReader, _super);
    function CellModelReader(properties, controlResolver, context) {
        return _super.call(this, 'cells', properties, controlResolver, context, new control_model_reader_1.ControlModelReader(properties, controlResolver, context)) || this;
    }
    CellModelReader.prototype.readValue = function (value) {
        var _this = this;
        if (!Array.isArray(value)) {
            throw new TypeError('One of the rows of the layout is not an array');
        }
        return value.map(function (valueObject) {
            var id = interpreter_utils_1.getOptionalProperty(valueObject, 'id', interpreter_utils_1.uniqueId());
            var cellModel = new cell_model_1.CellModel(id, _this.properties.getCellProperties(id), interpreter_utils_1.getOptionalProperty(valueObject, 'grid'), interpreter_utils_1.getOptionalProperty(valueObject, 'title', new __1.TitleModel()), interpreter_utils_1.getOptionalProperty(valueObject, 'control'));
            _this.correctControlProperties(cellModel);
            return cellModel;
        });
    };
    CellModelReader.prototype.correctControlProperties = function (cellModel) {
        if (this.properties.hasControlProperties(cellModel.id) && cellModel.controlModel) {
            var generatedId = cellModel.controlModel.properties.generatedId;
            cellModel.controlModel.properties = this.properties.getControlProperties(cellModel.id);
            cellModel.controlModel.properties.generatedId = generatedId;
        }
        else if (this.properties.hasControlProperties(cellModel.id)) {
            console.warn("cell with " + cellModel.id + " had control properties defined but had no control");
        }
    };
    return CellModelReader;
}(layout_reader_1.LayoutReader));
exports.CellModelReader = CellModelReader;
//# sourceMappingURL=cell-model-reader.js.map